import { Theme } from '@mui/material';
import { InvoiceStatus } from '@prisma/client';

function invoiceInfoBannerConfigs(invoiceStatus: InvoiceStatus, theme: Theme) {
    if (invoiceStatus === InvoiceStatus?.PROCESSING) {
        return {
            title: 'This invoice is still being processed',
            subText:
                'This invoice is currently being processed, no changes can be made until this has been completed',
            styles: {
                bgColor: theme.palette.background.info,
                borderStyle: theme.palette.border.info,
            },
        };
    } else if (invoiceStatus === InvoiceStatus?.FAILED) {
        return {
            title: 'This invoice failed to process',
            subText: `Please fix the failure reason before clicking 'Resubmit to Sage'`,
            styles: {
                bgColor: theme.palette.background.error,
                borderStyle: theme.palette.border.warn,
            },
        };
    } else if (invoiceStatus === InvoiceStatus?.PARTIALLY_FAILED) {
        return {
            title: 'This invoice has partially failed to be processed',
            subText: `Please fix the failure reason before clicking 'Release Invoice'`,
            styles: {
                bgColor: theme.palette.background.warn,
                borderStyle: theme.palette.border.error,
            },
        };
    }
    return null;
}

export default invoiceInfoBannerConfigs;
